import Swiper from "./swiper-bundle.esm.browser.min.js";

class VariantSwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.prevButton = null;
    this.nextButton = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    this.destroySwiper();
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
      this.prevButton = null;
      this.nextButton = null;
    }
  }

  getConfig(configScript) {
    try {
      return JSON.parse(configScript.textContent);
    } catch (error) {
      console.error('Error parsing variant swiper config:', error);
      return null;
    }
  }

  setupSlides(container) {
    const wrapper = container.querySelector('[data-variant-swiper-wrapper]');
    const slides = container.querySelectorAll('[data-variant-slide]');

    if (!wrapper || slides.length < 5) {
      return null;
    }

    wrapper.classList.add('swiper-wrapper');
    slides.forEach(slide => slide.classList.add('swiper-slide'));

    return slides;
  }

  cacheNavigationButtons(container) {
    this.prevButton = container.querySelector('.variant-swiper__nav-prev');
    this.nextButton = container.querySelector('.variant-swiper__nav-next');
  }

  updateNavigationVisibility = (swiper) => {
    if (this.prevButton) {
      this.prevButton.style.display = swiper.isBeginning ? 'none' : 'flex';
    }
    if (this.nextButton) {
      this.nextButton.style.display = swiper.isEnd ? 'none' : 'flex';
    }
  };

  initSwiper() {
    const container = this.querySelector('[data-variant-swiper]');
    if (!container) return;

    const configScript = container.querySelector('[data-variant-swiper-config]');
    if (!configScript) return;

    const config = this.getConfig(configScript);
    if (!config?.enabled) return;

    const slides = this.setupSlides(container);
    if (!slides) return;

    this.cacheNavigationButtons(container);

    // Inizializza Swiper
    this.swiper = new Swiper(container, {
      ...config,
      on: {
        init: this.updateNavigationVisibility,
        slideChange: this.updateNavigationVisibility
      }
    });
  }
}

if (!customElements.get('variant-swiper-slider')) {
  customElements.define('variant-swiper-slider', VariantSwiperSlider);
}
